import { useEffect, useRef, useState } from "react";
import { BookUser, Search } from "lucide-react";
import { api } from "@/lib/api";

export const toForm = (e) => ({ recipient_name: e.name, recipient_email: e.email, recipient_phone: e.phone || "", line1: e.line1, line2: e.line2 || "", line3: e.line3 || "", city: e.city, postcode: e.postcode });

export const AddressPicker = ({ onPick }) => {
  const [q, setQ] = useState("");
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(false);
  const box = useRef(null);
  useEffect(() => {
    const t = setTimeout(() => { api.get("/address-book", { params: { q } }).then((r) => setRows(r.data.entries.slice(0, 8))).catch(() => setRows([])); }, 200);
    return () => clearTimeout(t);
  }, [q]);
  useEffect(() => {
    const close = (e) => { if (box.current && !box.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, []);
  return (
    <div ref={box} className="relative sm:col-span-2" data-testid="address-picker">
      <label className="flex items-center gap-2 h-11 rounded-full border border-slate-300 dark:border-slate-700 bg-slate-50 dark:bg-slate-900 px-4 focus-within:border-emerald-500">
        <BookUser size={16} className="text-emerald-600 shrink-0" />
        <input data-testid="address-picker-input" value={q} onFocus={() => setOpen(true)} onChange={(e) => { setQ(e.target.value); setOpen(true); }}
          placeholder="Search address book" title="Search by name, email or postcode" className="flex-1 bg-transparent text-sm outline-none min-w-0" />
        <Search size={14} className="text-slate-400" />
      </label>
      {open && (
        <ul data-testid="address-picker-results" className="absolute z-20 mt-1 w-full rounded-xl border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 shadow-lg max-h-72 overflow-y-auto">
          {rows.length === 0 ? <li className="px-4 py-3 text-sm text-slate-500" data-testid="address-picker-empty">{q ? "No matches" : "Your address book is empty. Recipients you send to can be saved automatically."}</li>
            : rows.map((e) => (
              <li key={e.id}><button type="button" data-testid={`address-picker-option-${e.id.slice(0, 8)}`} onClick={() => { onPick(toForm(e)); setOpen(false); setQ(""); }}
                className="w-full text-left px-4 py-2.5 hover:bg-emerald-50 dark:hover:bg-emerald-950/40 transition-colors">
                <span className="block text-sm font-semibold">{e.name} {e.scope === "org" && <span className="ml-1 text-[10px] uppercase tracking-wider text-emerald-600">Organisation</span>}</span>
                <span className="block text-xs text-slate-500 truncate">{e.email} · {[e.line1, e.city, e.postcode].filter(Boolean).join(", ")}</span>
              </button></li>
            ))}
        </ul>
      )}
    </div>
  );
};
